import React, { useEffect, useState } from 'react';
import StudentsInfo from './studentsInfo';
import { getStudentsProfile, getTeacherByClassId, getUser } from '../../../actions';
import jwt from 'jwt-decode';

const StudentsProfile = () => {
  const [student, setStudent] = useState();
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [added, setAdded] = useState('')

  useEffect(() => {
    getStudentsProfile()
      .then(({ data }) => {
        const studentData = {
          ...data,
          studyYear: data.studyYear,
          class: data.class && data.class.year && data.class.letter ? (data.class.year + data.class.letter) : '',
        };
        getTeacherByClassId(data.classId)
          .then(({ data }) => setStudent({
            ...studentData,
            classroomTeacher: (data.lastName + ' ' + data.firstName + ' ' + data.middleName)
          }))
          .catch(() => {
            setStudent(studentData)
          })

      })
    const t = localStorage.getItem('token');
    const persistedToken = jwt(t);
    if (persistedToken && persistedToken['nameid']) {
      setLoading(true);
      getUser(persistedToken['nameid']).then((res) => {
        setUser(res.data);
        setLoading(false);
      });
    }
  }, []);

  useEffect(() => {
    if (added) {
      setAdded(false)
      getStudentsProfile()
        .then(({ data }) => {
          const studentData = {
            ...data,
            studyYear: data.studyYear,
            class: data.class && data.class.year && data.class.letter ? (data.class.year + data.class.letter) : '',
          };
          getTeacherByClassId(data.classId)
            .then(({ data }) => setStudent({
              ...studentData,
              classroomTeacher: (data.lastName + ' ' + data.firstName + ' ' + data.middleName)
            }))
            .catch(() => {
              setStudent(studentData)
            })

        })
      const t = localStorage.getItem('token');
      const persistedToken = jwt(t);
      if (persistedToken && persistedToken['nameid']) {
        setLoading(true);
        getUser(persistedToken['nameid']).then((res) => {
          setUser(res.data);
          setLoading(false);
        });
      }
    }
  }, [added]);

  return (
    <>
      {
        student &&
        <StudentsInfo student={student} user={user} loading={loading} setAdded={setAdded} />
      }
    </>
  );
};

export default StudentsProfile;
